import React, { useState, useEffect } from "react";
import { UserProfile } from "../userProfile";
import { BasicDetails } from "./basicDetails";
import { FamilyInfo } from "./familyInformation";
import { EducationDetails } from "./educationDetails";
import { DocumentInfo } from "./documentInfo";
import { OtherInfo } from "./otherInfo";
import { WalletInfo } from "./walletInfo";
import { axiosInstance } from "../../axiosInstance-user";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";

export function UserprofileEdit() {
  const [content, setContent] = useState(<BasicDetails />);
  const [activeMenu, setActiveMenu] = useState("basic");

  function handleBasic() {
    setContent(<BasicDetails />);
    setActiveMenu("basic");
  }
  function handleFamily() {
    setContent(<FamilyInfo />);
    setActiveMenu("family");
  }
  function handleEducation() {
    setContent(<EducationDetails />);
    setActiveMenu("education");
  }
   function handleOther() {
    setContent(<OtherInfo />);
    setActiveMenu("other");
  }
  function handleDocument() {
    setContent(<DocumentInfo/>);
    setActiveMenu("document");
  }
 
  // function handleWallet() {
  //   setContent(<WalletInfo/>);
  //   setActiveMenu("wallet");
  // }
  return (
  <>
  <ToastContainer/>
    <div>
      <div className="userEdit-subcontainer">
        {/* here onContentChange is a function coming from index.js */}
        <Link to="/user-profiles">
         <div
          className="bi bi-arrow-left"
        
        ></div>
        </Link>
       

        <div className="menuContainer">
          <div className="menu">
            <div
              onClick={handleBasic}
              className={activeMenu === "basic" ? "active" : ""}
            >
              Basic Information
            </div>
            <div
              onClick={handleFamily}
              className={activeMenu === "family" ? "active" : ""}
            >
              Family Information
            </div>
            <div
              onClick={handleEducation}
              className={activeMenu === "education" ? "active" : ""}
            >
              Educational Information
            </div>
             <div
              onClick={handleOther}
              className={activeMenu === "other" ? "active" : ""}
            >
              Other Information
            </div>
            <div
              onClick={handleDocument}
              className={activeMenu === "document" ? "active" : ""}
            >
              Documents Information
            </div>
           
            {/* <div
              onClick={handleWallet}
              className={activeMenu === "wallet" ? "active" : ""}
            >
              Wallet Information
            </div> */}
          </div>
        </div>
      </div>
      <div className="content-part">{content}</div>
    </div>
  </>
  );
}
